import { NavigateFunction } from 'react-router-dom';

class NavigationService {
  private static navigate: NavigateFunction | null = null;

  static setNavigate(navigate: NavigateFunction) {
    NavigationService.navigate = navigate;
  }

  static navigateTo(path: string) {
    if (NavigationService.navigate) {
      NavigationService.navigate(path);
    } else {
      // Fallback to window.location if navigate is not available (full page load / possible reload)
      console.log('[NavigationService] Reload/navigate via window.location.href (navigate not set)', { path });
      window.location.href = path;
    }
  }
}

export default NavigationService; 